import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

/**
 * Specification of the fade duration given in milliseconds.
 */
const DURATION = 275;

/**
 * Css fade transition that'll fade the throbber out of view as needed.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const ContentFade: React.FC<{
  in?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      classNames="iframe__contentFade"
      timeout={DURATION}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .iframe__contentFade-enter {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;

            /** Prepare fade-in */
            opacity: 0.001;
          }

          .iframe__contentFade-enter-active {
            opacity: 1;
            transition: opacity ${DURATION}ms linear;
          }

          .iframe__contentFade-exit {
            /** Underlap the block */
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;

            /** Preapre fade-out */
            opacity: 1;
          }

          .iframe__contentFade-exit-active {
            opacity: 0.001;
            transition: opacity ${DURATION}ms linear;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
